import { useModalContext } from '#pplx/frontend/aether/modals/context/useModalContext.js';
import { useToastContext } from '#pplx/frontend/aether/toasts/context/useToastContext.js';
import { enterpriseViewerSubmissionDeniedEvent } from '#pplx/frontend/apps/ask/events/enterprise-viewer/analytics.js';
import { useOrgUpgradeRequestsAllowed } from '#pplx/frontend/apps/ask/organization/hooks/useOrgUpgradeRequestsAllowed.js';
import { usePaywallModalsOptional } from '#pplx/frontend/apps/ask/paywall-ui/context/PaywallModalsContextSupport.js';
import { useSession } from '#pplx/frontend/auth/useSession.js';
import { ModalOrigin } from '#pplx/frontend/components/types/types.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useCallback } from 'react';
const ViewerSeatRequestModal = Dynamic(async () => {
    const { ViewerSeatRequestModal } = await import('#pplx/frontend/apps/ask/hooks/pricing-hooks/ViewerSeatRequestModal.js');
    return { default: ViewerSeatRequestModal };
});
export function useRefuseViewerSubmission(restriction, origin = ModalOrigin.COMPUTER_PAGE) {
    const { session } = useSession();
    const { track } = useInstrumentation();
    const { openModal } = useModalContext();
    const paywallModals = usePaywallModalsOptional();
    const { openToast } = useToastContext();
    const upgradeRequestsAllowed = useOrgUpgradeRequestsAllowed({
        reason: 'viewer-submission-upgrade',
        enabled: restriction !== undefined,
        requireLoadedPolicy: true,
    });
    const canRequestUpgrade = session?.user?.org_role === 'MEMBER' && upgradeRequestsAllowed;
    return useCallback(() => {
        if (restriction === undefined)
            return false;
        let presentation;
        if (canRequestUpgrade && paywallModals) {
            openModal(ViewerSeatRequestModal, { origin: ModalOrigin.VIEWER_SEAT_REQUEST, ...paywallModals }, { replace: false });
            presentation = 'modal';
        }
        else {
            openToast({ message: restriction, variant: 'neutral', timeoutSeconds: 5 });
            presentation = 'toast';
        }
        track(enterpriseViewerSubmissionDeniedEvent({
            name: 'enterprise viewer submission denied',
            data: { origin, presentation },
        }));
        return true;
    }, [restriction, canRequestUpgrade, paywallModals, openModal, openToast, origin, track]);
}
//# sourceMappingURL=useRefuseViewerSubmission.js.map